module.exports = __webpack_public_path__ + "static/img/seafile-logo.98d4614.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/seafile-logo.png
// module id = w2Zq
// module chunks = 0